import { render, staticRenderFns } from "./TicketAdditionalInfor.vue?vue&type=template&id=e56e22b6&scoped=true"
import script from "./TicketAdditionalInfor.vue?vue&type=script&lang=js"
export * from "./TicketAdditionalInfor.vue?vue&type=script&lang=js"
import style0 from "./TicketAdditionalInfor.vue?vue&type=style&index=0&id=e56e22b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56e22b6",
  null
  
)

export default component.exports